"use client";
import { jsx as a, Fragment as n } from "react/jsx-runtime";
import { ikp as r } from "./factory.js";
import { CustomIcon as c } from "../atoms/icons/custom-icon.js";
import { useInkeepConfig as o } from "../providers/config-provider.js";
const K = r("div", {
  _id: "searchBar__Container"
}), l = r("button", {
  _id: "searchBar__Button",
  type: "button"
}), v = r("div", {
  _id: "searchBar__ContentWrapper"
}), s = r("div", {
  _id: "searchBar__Text"
}), b = (e) => {
  const {
    searchSettings: { placeholder: t }
  } = o();
  return /* @__PURE__ */ a(s, { ...e, children: t });
}, C = r(c, {
  _id: "searchBar__Icon",
  iconKey: "search"
}), f = r("kbd", {
  _id: "searchBar__KbdWrapper"
}), h = r("kbd", {
  _id: "searchBar__KbdShortcutKey"
}), P = (e) => {
  const { shortcutKey: t, ...i } = e;
  return /* @__PURE__ */ a(h, { ...i, children: t?.toUpperCase() });
}, d = () => {
  if (typeof window > "u")
    return !1;
  const e = window.navigator?.userAgent?.toLowerCase();
  return e.includes("macintosh") || e.includes("mac os x");
}, B = r("kbd", {
  _id: "searchBar__Ctrl",
  children: "Ctrl"
}), m = r(c, {
  _id: "searchBar__CmdIcon",
  iconKey: "command"
}), y = (e) => {
  const { shortcutKey: t, ...i } = e;
  return /* @__PURE__ */ a(n, { children: t ? d() ? /* @__PURE__ */ a(m, { ...i }) : /* @__PURE__ */ a(B, { ...i }) : null });
};
export {
  l as SearchBarButton,
  K as SearchBarContainer,
  v as SearchBarContentWrapper,
  C as SearchBarIcon,
  y as SearchBarKbdModifier,
  P as SearchBarKbdShortcutKey,
  f as SearchBarKbdWrapper,
  b as SearchBarText
};
